import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./components/_default/context/ShoppingCartContext"
import store from "./store/store"
import Redirect from "./components/_default/utilities/Redirect"
import TagManager from 'react-gtm-module'
// Pages
import Webpage454Avaleht from "./pages/Webpage454Avaleht";

var baseURL = 'https://d2.itprojektid.ee/webstoreApi';
var axiosHeaders = {
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxMSIsImp0aSI6IjE4OWExNzM3ZmQ3MTU0MmUxZGNhODNhZjExNWE0Zjk0ZWI3MTc5YTM1OTZlNTNlZDcxN2MxMjAzZWI1OTU3ZGY4M2E0OWMzNzk3MGQzZWQ1IiwiaWF0IjoxNzQ0Mjc5MzAxLjI3MDM1NCwibmJmIjoxNzQ0Mjc5MzAxLjI3MDM2MywiZXhwIjoxNzQ0MzY1NzAxLjI2NTU1OSwic3ViIjoiNzUiLCJzY29wZXMiOltdfQ.09qZID79Zd28_ERKDhXSbHDyh0fjWMX7FcEPnqyXPtCTZxjFukJSdzndr3yw_JzQ4I76kLk6IdLn45UiJsHEvLYLHJYURKWjG1OpHAJZ409P06i-kAp7LYHMONqNnJZioT3ZlhkawvVAYmmUCiCNIXtqmh0Djoc8FeFEsPweeKToK7XocuQMFpXyWxcR2hz5lqAn-vRNmscbZ2iuka7R9JfqFFd6shL3vr0RRpo3U5eVCK7NVgaPO-ZYv9IRkCBEuKDv4HIcH37bSDW26_L-Vsk2f3K6jciII1s_mkwV4kFxgKR1oZX_KY24P9beojT9zxyaLeuSe697v8WkF2Yb2dJlRzWKFpAjoUaXZ_bh9ZK4skuxfTt_-ZkgzseA6TlZOTiU4afKiw7x1wUOVX4_BUzf1u6AP7-Ze9MYG15kPJfIMrr_ez8vdo3s1FyNhRQ3VJVeOUvcYQs49OeSXQUVvMcNO4iO0csW4VhO7fw_CQ6pKt-dP-4I3uzCIZwlRRgeq0O8XKtzRLJtyx3_G35CJzeoCDq3Kfo48cJ6-xzsmUnK41qb7lglx6DSFcZgTo_nD4-ey8kIN9GqhSG1ez2R_dUZGpF8J4iQ32XTiQ4z8FwKmyyeNLGhz2AUWN0-IAK_1bohLcM_w6PQ0nT3PClpQhQRjgkDcPOeH7iLyDsS62o',
    'Access-api-key': "eyJpdiI6Imx6eDM1WnZtL3grZ1ZTN1lrTVZQM0E9PSIsInZhbHVlIjoiQ2RvSjRSa3JtZVhNd1dSRkZMVzA2Zz09IiwibWFjIjoiYjkzNDdhNWMyN2ZiYjNlYmYzZjc1ODI3NmM3OTg1YjI3OTIyODA0OGE5OWQwZTRmNThmOWZlNTdkZjM3ZTYxMCIsInRhZyI6IiJ9",
    'Access-api-id': "eyJpdiI6Ii9TaWUvUy9NTGttZDNQMHhhNUZOc3c9PSIsInZhbHVlIjoiNklFaHRCaE1IRFpscS8zVTNBbUxIZz09IiwibWFjIjoiNWVhMjMwMDE5NDVhMzRlZDRjMTk3MWViNDExZmZhMDRiNDU1YmY5ZjZjNzc3MWI2ZjFlOWI4ZjYxODc4N2ZkYSIsInRhZyI6IiJ9",
    'Access-Control-Allow-Origin': "*"
 };


window.axios = require('axios').create({
  baseURL: baseURL,
  headers: axiosHeaders
});
const tagManagerArgs = {
    gtmId: ""
}
TagManager.initialize(tagManagerArgs)
    
export default function App() {
    window.dataLayer.push({
        event: 'pageview'
    });
    return (
        <Provider store={store}>
            <ShoppingCartProvider>
                <BrowserRouter basename="/">
                    <Routes>
                                            <Route path="/et//" element={<Webpage454Avaleht />} exact />;
                                                                
                                                                <Route path="*" element={<Webpage454Avaleht />} exact />;
                                        </Routes>
                </BrowserRouter>
            </ShoppingCartProvider>
        </Provider>
    );
}